import { render, staticRenderFns } from "./NewsletterRegistrationDialog.vue?vue&type=template&id=7134a084&"
import script from "./NewsletterRegistrationDialog.vue?vue&type=script&lang=js&"
export * from "./NewsletterRegistrationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports